import { z } from "zod";
import { ExternalInvitationAction } from "../enum-external-invitation.js";

export const respondExternalInvitationSchema = z
	.object({
		action: z.enum([ExternalInvitationAction.ACCEPTED, ExternalInvitationAction.DECLINED]),
		first_name: z.string().min(1).max(100).optional(),
		last_name: z.string().min(1).max(100).optional(),
	})
	.superRefine((data, ctx) => {
		if (data.action === ExternalInvitationAction.ACCEPTED) {
			if (!data.first_name) ctx.addIssue({ code: "custom", path: ["first_name"], message: "first_name is required when accepting" });
			if (!data.last_name) ctx.addIssue({ code: "custom", path: ["last_name"], message: "last_name is required when accepting" });
		}
	});

export type RespondExternalInvitationPayload = z.infer<typeof respondExternalInvitationSchema>;
